function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as l } from "react/jsx-runtime";
import { useIsInverseVariant as s } from "../../theme-variant-context.js";
import { vars as a } from "../../skins/skin-contract.css-mistica.js";
const n = (_param)=>{
    var { color: r , size: c = 24  } = _param, o = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const e = s(), t = r !== null && r !== void 0 ? r : e ? a.colors.inverse : a.colors.neutralHigh;
    return /* @__PURE__ */ l("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, o), {
        children: /* @__PURE__ */ l("path", {
            fill: t,
            d: "M16.9 6.962c2.325-.656 4.098.358 4.748 2.722.647 2.37-.356 4.18-2.684 4.838a3.9 3.9 0 01-.952.126c.342.283.641.585.857.91v.003c.661.995.916 2.025.74 2.975-.177.955-.788 1.812-1.762 2.484-.788.547-1.577.816-2.325.816-1.149 0-2.202-.63-3.023-1.86a4.237 4.237 0 01-.462-1.003 4.376 4.376 0 01-.47 1.02c-.662.991-1.505 1.613-2.44 1.792-.19.04-.387.056-.583.056-.762 0-1.554-.274-2.325-.812-1.991-1.373-2.375-3.412-1.022-5.454a4.34 4.34 0 01.843-.905 3.893 3.893 0 01-1.014-.134C2.7 13.878 1.7 12.068 2.348 9.698c.314-1.156.922-2.02 1.75-2.495.83-.474 1.866-.552 2.998-.227.457.131.919.392 1.373.714-.197-.557-.323-1.11-.32-1.616 0-2.451 1.443-3.919 3.857-3.919h.003c2.412.011 3.846 1.485 3.838 3.944 0 .49-.126 1.028-.317 1.574.454-.322.916-.582 1.37-.711zm-2.277-.869c.005-1.753-.9-2.683-2.62-2.691-1.72 0-2.63.927-2.63 2.677-.005.81.51 2.068 1.42 3.499.014-.006.03-.009.045-.012l.023-.005c.14-.045.285-.078.442-.106l.107-.017a3.947 3.947 0 011.692.112l.036.009a.293.293 0 01.053.013c.916-1.434 1.432-2.686 1.432-3.479zm.319 6.765c1.613.51 2.944.678 3.695.468 1.658-.474 2.29-1.616 1.829-3.305-.463-1.684-1.583-2.328-3.241-1.855-.74.21-1.76 1.023-2.843 2.255.011.013.02.029.03.044a.397.397 0 00.02.032l.05.081a2.676 2.676 0 01.318.697l.016.056c.03.11.056.225.075.337l.014.084.014.084c.045.339.054.68.023 1.022zm3.465 5.445c.117-.63-.067-1.316-.546-2.039-.468-.697-1.647-1.465-3.28-2.143l-.023.031-.022.031c-.07.115-.146.224-.23.325l-.027.036a.61.61 0 01-.037.048 2.56 2.56 0 01-.37.325.966.966 0 01-.049.03 2.63 2.63 0 01-.402.22c-.025.009-.05.02-.074.03l-.075.03c-.14.054-.283.096-.428.127l-.034.01a.31.31 0 01-.042.012c.014 1.796.28 3.202.745 3.9.967 1.45 2.227 1.697 3.647.714.71-.49 1.13-1.056 1.247-1.686zM8.9 20.561c.619-.12 1.176-.546 1.658-1.269.462-.697.728-2.1.74-3.899a.543.543 0 01-.06-.017.543.543 0 00-.06-.016 2.63 2.63 0 01-.894-.342l-.058-.033a.524.524 0 01-.057-.032 2.247 2.247 0 01-.373-.316l-.043-.052a2.617 2.617 0 01-.265-.354.246.246 0 00-.025-.035.253.253 0 01-.025-.035c-1.614.675-2.776 1.434-3.23 2.117-.964 1.454-.723 2.74.697 3.72.71.493 1.376.678 1.995.563zm-3.546-7.224c.762.221 2.092.048 3.703-.462a4.673 4.673 0 01.036-1.149l.02-.103.017-.084a3.66 3.66 0 01.131-.457l.017-.047a2.543 2.543 0 01.316-.602c-1.075-1.23-2.09-2.04-2.829-2.253a3.555 3.555 0 00-.991-.154 2.121 2.121 0 00-1.076.266c-.546.314-.941.902-1.17 1.743-.23.843-.191 1.551.117 2.109.308.557.882.958 1.709 1.193zm6.784.857c1.11-.042 1.392-.577 1.513-1.042v-.003c.061-.24.09-.484.084-.73 0-.707-.185-1.2-.547-1.471a1.108 1.108 0 01-.095-.062c-.269-.165-.636-.25-1.098-.25-.46 0-.832.088-1.106.259l-.05.029a.568.568 0 00-.051.032c-.353.277-.532.768-.532 1.462 0 .126.008.252.02.376a.907.907 0 00.011.066c.004.02.008.04.01.06l.008.049c.008.053.016.106.03.155.007.02.016.042.021.065.118.423.41.988 1.566 1.014h.076c.048-.006.092-.009.14-.009z"
        })
    }));
}, v = n;
export { v as default };
